import * as angular from "angular";
import * as _ from "lodash";
import * as $ from "jquery";
import {IHttpService, IQService} from "angular";
import {SplitService} from "./split-service.service";
import {BringozLoaderService} from "./bringoz-loader.service";
import {CommonsAlertsService} from "./commons-alerts.service";
import {ApiConfig} from "../models/api-config.model";
import {RecurringType} from "../types/recurring.type";

export class CommonsService {

  tooltipRef: any;
  colors: any;
  private bodyElement: any;

  constructor(private $mdPanel, private $q: IQService, private commonsConstants, private moment,
              private $http: IHttpService, private $document,
              private uploadFile, private Upload, private bringozLoaderService: BringozLoaderService, private splitService: SplitService,
              private apiConfig: ApiConfig, private commonsAlertsService: CommonsAlertsService) {
    this.colors = this.commonsConstants.colorPalletOne;
    this.bodyElement = angular.element(this.$document);
  }

  getConfirmActions(actionsList, enabled?: boolean) {
    const actions = _.map(actionsList, action => {
      return {
        title: action,
        enabled: enabled !== undefined ? enabled : true
      }
    })
    return actions;
  }

  resetFilterField(filters: any, filterName: string, excludeIdsMap?: any) {
    if (filterName === 'groupIds' && excludeIdsMap) {
      excludeIdsMap.branchIds = [];
    }

    if ((filterName === 'accountPickup' && !filters.accountDropoff) || (filterName === 'accountDropoff' && !filters.accountPickup)) {
      filters.taskAccountIds = [];
    }

    filters[filterName] = _.isArray(filters[filterName]) ? [] : undefined;

    if (filterName === 'serviceAreaIds' && !_.isUndefined(filters.noArea) && !_.isUndefined(filters.noPickUpArea) && !_.isUndefined(filters.noDropOffArea)) {
      filters.noArea = false;
      filters.noDropOffArea = false;
      filters.noPickUpArea = false;
    }

    if (filterName === 'branchIds' && !_.isUndefined(filters.noBranches)) {
      filters.noBranches = false;
    }
  }

  openActionPanel(actions?, $event?, header?, isPositionNextToElement?, bringozIdContext?) {

    const deferred = this.$q.defer(),
      yPosition = this.$mdPanel.yPosition.CENTER,
      xPosition = isPositionNextToElement ?
        this.$mdPanel.xPosition.OFFSET_END :
        this.$mdPanel.yPosition.CENTER;

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(xPosition, yPosition);

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .withAnimation(this.$mdPanel.animation.FADE);


    const config = {
      attachTo: angular.element(document.body),
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<commons-action-panel actions="ctrl.actions" header="ctrl.header" panel-ref="ctrl.mdPanelRef" bringoz-id-context="ctrl.bringozIdContext"></commons-action-panel>',
      controller: function () {
        this.actions = actions;
        this.header = header;
        this.bringozIdContext = bringozIdContext || '';
      },
      controllerAs: 'ctrl',
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, reason) => {
        if (_.isEqual(reason, 'clickOutsideToClose')) {
          deferred.reject(reason);
        } else {
          panel.destroy();
          deferred.resolve(reason);
        }
      }
    };

    this.$mdPanel.open(config);
    return deferred.promise;
  }

  getColorById(id, colors?) {
    const hash = this.hashStr(id);
    const index = hash % (colors?.length || this.colors.length);
    return colors ? colors[index] : this.colors[index];
  }

  capitalize(string) {
    const REGEX = /([^\W_]+[^\s-]*) */g;
    if (!string) return '';
    return string.replace(REGEX, function (text) {
      return text.charAt(0).toUpperCase() + text.substr(1).toLowerCase();
    })
  }

  getGreetingTime() {
    let g = null; //return g
    const m = this.moment();
    const split_afternoon = 12 //24hr time to split the afternoon
    const split_evening = 17 //24hr time to split the evening
    const currentHour = parseFloat(m.format("HH"));

    if (currentHour >= split_afternoon && currentHour <= split_evening) {
      g = "afternoon";
    } else if (currentHour >= split_evening) {
      g = "evening";
    } else {
      g = "morning";
    }

    return g;
  }

  fileUpload(mimeTypes) {
    const deferred = this.$q.defer();
    const input = $('<input id="upload" type="file" accept="' + mimeTypes + '" style="display: none;">');

    input.trigger('click');

    input.change(() => {
      if (input[0].files) {
        this.bringozLoaderService.on();
        this.uploadFile(input[0].files[0])
          .then((response) => {

            if (response.data) {
              deferred.resolve(response.data);
            }
          })
          .catch((error) => {
            if (error.data.message === "Constraint violation failed") {
              this.commonsAlertsService.fileFormatError();
            }
            deferred.reject(error);
          })
          .finally(() => {
            this.bringozLoaderService.off();
            input.val(null);
          })
      }
    });

    return deferred.promise
  }

  getIkeaPrinters() {
    const siteId = this.splitService.getSiteId();
    const url = this.apiConfig.baseUrl + `/printers`;
    return this.$http.get(url, {
      params: {
        siteId: siteId
      }
    }).then(res => this.sendResponseData(res))
      .catch(err => this.sendError(err));
  }

  printIkea(serviceIds, printerName, printType, numberOfStickers, depotId) {
    const siteId = this.splitService.getSiteId();
    const url = this.apiConfig.baseUrl + `/printers/` + printerName + '/print';
    const body = {
      serviceIds: serviceIds,
      requestType: printType,
      numberOfStickers: numberOfStickers,
      printOnDepotId: depotId
    }
    return this.$http.post(url, body, {
      params: {
        siteId: siteId
      }
    }).then(res => this.sendResponseData(res))
      .catch(err => this.sendError(err));
  }

  lightenDarkenColor(col, amt) {

    let usePound = false;

    if (col[0] == "#") {
      col = col.slice(1);
      usePound = true;
    }

    let num = parseInt(col, 16);

    let r = (num >> 16) + amt;

    if (r > 255) r = 255;
    else if (r < 0) r = 0;

    let b = ((num >> 8) & 0x00FF) + amt;

    if (b > 255) b = 255;
    else if (b < 0) b = 0;

    let g = (num & 0x0000FF) + amt;

    if (g > 255) g = 255;
    else if (g < 0) g = 0;

    return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);

  }

  parseArrayStateParam(val) {
    if (!val) {
      return;
    }
    return _.isArray(val) ? val : [val]
  }

  bindUserEvents(cb) {
    // Bind User Event Listeners
    angular.forEach(['keydown', 'keyup', 'click', 'mousemove', 'DOMMouseScroll', 'mousewheel', 'mousedown', 'touchstart', 'touchmove', 'scroll', 'focus'],
      (EventName) => {
        this.bodyElement.bind(EventName, (e) => {
          cb(e);
        });
      });
  }

  getPackageWeight(packageRef): number | undefined {
    let hasAnyWeight = false;
    const weight = _.reduce(packageRef.items, (sum, i) => {
      if (!_.isUndefined(i.weight)) {
        hasAnyWeight = true;
      }
      return sum + _.get(i, 'weight', 0);
    }, 0);

    return hasAnyWeight ? +weight : undefined;
  }

  calculateTableColumnsTotalWidth(columns, dynamicColumns?, dynamicColumnSize?: number): number {
    let columnsTotalWidth = 0;

    _.forOwn(columns, c => {
      if (c.enabled) {
        columnsTotalWidth += this.commonsConstants.tableColumnSizes[c.size]
      }
    });

    _.forOwn(dynamicColumns, c => {
      if (c.enabled) {
        columnsTotalWidth += dynamicColumnSize;
      }
    });

    return columnsTotalWidth;
  }

  hexToRGBColor(hex, alpha?) {
    hex = hex.replace(/^#/, '');
    let r, g, b;

    if (hex.length === 3) {
      r = parseInt(hex[0] + hex[0], 16);
      g = parseInt(hex[1] + hex[1], 16);
      b = parseInt(hex[2] + hex[2], 16);
    } else if (hex.length === 6) {
      r = parseInt(hex.slice(0, 2), 16);
      g = parseInt(hex.slice(2, 4), 16);
      b = parseInt(hex.slice(4, 6), 16);
    } else {
      throw new Error('Invalid hex color code');
    }

    if (!!alpha) {
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    } else {
      return `rgb(${r}, ${g}, ${b})`;
    }
  }

  checkIfArraysMatch(arr1, arr2) {

    if (!arr1 || !arr2) {
      return;
    }

    if (arr1.length !== arr1.length) {
      return false;
    }

    //The slice to create shallow copy because sorting happens on the original array.
    const sortedArray1 = arr1.slice().sort();
    const sortedArray2 = arr2.slice().sort();

    for (let i = 0; i < sortedArray1.length; i++) {
      if (sortedArray1[i] !== sortedArray2[i]) {
        return false;
      }
    }

    return true;
  }

  findInObjArray(array, value) {
    let found = [];

    function findInObj(obj, value) {
      return Object.values(obj).some(v => typeof v == 'object' && v !== null ? findInObj(v, value) :
        typeof v == 'string' ? v.indexOf(value) >= 0 : typeof v == 'number' ? v === value || isNaN(v) && isNaN(value) : v === value
      );
    }

    array.forEach((obj) => {
      if (findInObj(obj, value)) found.push(obj);
    })

    return found;
  }

  generateCronExpression(scheduleSeconds, scheduleHour, scheduleMinutes, recurringType?, weekDays?: any) {
    let hours, minutes, seconds, dayOfWeek;

    //Seconds
    if (isNaN(scheduleSeconds) || _.isNull(scheduleSeconds)) {
      seconds = "00"
    } else if (scheduleSeconds < 10) {
      seconds = 0 + scheduleSeconds.toString();
    } else {
      seconds = scheduleSeconds.toString();
    }

    //Minutes
    if (isNaN(scheduleMinutes) || _.isNull(scheduleMinutes)) {
      minutes = "00"
    } else if (scheduleMinutes < 10) {
      minutes = 0 + scheduleMinutes.toString();
    } else {
      minutes = scheduleMinutes.toString();
    }

    //Hours
    if (isNaN(scheduleHour) || _.isNull(scheduleHour)) {
      hours = "00"
    } else if (scheduleHour < 10) {
      hours = 0 + scheduleHour.toString();
    } else {
      hours = scheduleHour.toString();
    }


    // Week Days if Recurring type is weekly
    if (recurringType === RecurringType.WEEKLY && weekDays.length) {
      dayOfWeek = weekDays.join(',');
    } else {
      dayOfWeek = '*'
    }

    //// Add logic
    const dayOfMonth = '*';
    const month = '*';

    return `${seconds} ${minutes} ${hours} ${dayOfMonth} ${month} ${dayOfWeek}`;
  }

  parseCronExpression(cronExpression: string) {
    const parts = cronExpression.split(' ');

    if (parts.length !== 6) {
      console.error('Invalid cron expression format');
    }

    const cronMinutes = parts[1] === '*' ? undefined : parseInt(parts[1], 10);
    const cronHours = parts[2] === '*' ? undefined : parseInt(parts[2], 10);

    let recurringType, selectedWeekDays;

    if (parts[5] !== '*') {
      recurringType = RecurringType.WEEKLY;
      selectedWeekDays = parts[5].split(',').map(n => parseInt(n, 10));
    } else {
      recurringType = RecurringType.DAILY;
      selectedWeekDays = [];
    }

    return {
      cronMinutes: cronMinutes,
      cronHours: cronHours,
      recurringType: recurringType,
      selectedWeekDays: selectedWeekDays
    }
  }


  buildZxExtras(email: string, name?: string) {
    const emailLowerCase = email.toLowerCase();
    const displayName = (name || "").toLowerCase();

    // split email into meaningful parts
    const emailParts = emailLowerCase.split(/[@._-]/).filter(Boolean);

    // split display name (first/last/etc.)
    const nameParts = displayName.split(/\s+/).filter(Boolean);

    return [
      email,
      displayName,
      ...emailParts,
      ...nameParts
    ];
  }


  // ******************************
  //        Private methods
  // ******************************

  //simple hash

  private hashStr(str) {
    let hash = 0;
    if (str) {
      for (let i = 0; i < str.length; i++) {
        let charCode = str.charCodeAt(i);
        hash += charCode;
      }
    }
    return hash;
  }

  private sendResponseData(response) {
    return this.$q.resolve(response.data);
  }

  private sendError(response) {
    return this.$q.reject(response.data);
  }
}

angular
  .module('bringoz.admin.commons')
  .service('commonsService', CommonsService);
